import { Button } from '@iwoca/orion';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import greenTickSvg from './greenTick.svg';
import styles from './CrossSellWarningModal.module.css';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    applyForFlexi: () =>
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: { pathname: '/apply-flexi-loan/', search: '?ipxsell=1' }
        } as const)
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const BetterOptionItem = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className={styles.betterOptionItem}>
            <span className={styles.benefitIcon}>
                <img src={greenTickSvg} alt="Green Tick" />
            </span>
            {children}
        </div>
    );
};

export const CrossSellWarningModal = ({ applyForFlexi }: PropsFromRedux) => {
    return (
        <div
            className={styles.modalWrapper}
            data-testid="iwocapay-cross-sell-modal"
        >
            <div className={styles.betterOptionTitle}>
                A Flexi-Loan might be a better option if:
            </div>
            <BetterOptionItem>You need more than £15,000</BetterOptionItem>
            <BetterOptionItem>
                You need funds to pay someone other than an iwocaPay supplier
            </BetterOptionItem>
            <div className={styles.applyButton}>
                <Button variant="primary" onClick={applyForFlexi}>
                    Apply for a Flexi-Loan
                </Button>
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(CrossSellWarningModal);
